import { gql } from '@apollo/client';
import { rateUnitFragment, sellerFragment } from 'helper/fragment';

export const CREATE_TRADER_TAG = gql`
  mutation CreateTraderTag($input: TraderTagInputDTO!) {
    createTraderTag(traderTagInputDTO: $input)
  }
`;

export const ASSIGN_TRADER_TAG = gql`
  mutation AssignTraderTag($userId: ID!, $traderTagId: ID!) {
    assignTraderTag(userId: $userId, traderTagId: $traderTagId)
  }
`;

export const GET_ALL_TRADER_TAGS = gql`
  query GetAllTraderTags {
    getAllTraderTags {
      id
      tagName
      colorCode
      isDeleted
    }
  }
`;

export const VENDOR_BIDS = gql`
  ${rateUnitFragment}
  query bids(
    $filter: [FilterMap]
    $pageNo: Int
    $pageSize: Int
    $sortCol: String
    $sortDirection: String
  ) {
    bids(
      filter: $filter
      pageNo: $pageNo
      pageSize: $pageSize
      sortCol: $sortCol
      sortDirection: $sortDirection
    ) {
      bids {
        id
        bidType
        bidderRole
        childBids {
          bidder {
            firstName
          }
          price
          quantity
          quantityUnit
          rateUnit {
            ...rateUnitInfo
          }
          bidType
        }
        bidder {
          id
          firstName
          entityName
          tradeName
          status
          addresses {
            id
            houseNumber
            city {
              cityName
            }
            state {
              stateName
            }
          }
        }
        offer {
          id
          offerType
        }
        demand {
          id
        }
        grade {
          id
          name
        }
      }
    }
  }
`;

export const VENDOR_ORDERS = gql`
  ${sellerFragment}
  ${rateUnitFragment}
  query orders(
    $filter: [FilterMap]
    $pageNo: Int
    $pageSize: Int
    $sortCol: String
    $sortDirection: String
  ) {
    orders(
      filter: $filter
      pageNo: $pageNo
      pageSize: $pageSize
      sortCol: $sortCol
      sortDirection: $sortDirection
    ) {
      orders {
        id
        seller {
          ...sellerInfo
        }
        status
        rate
        quantity
        rateUnit {
          ...rateUnitInfo
        }
        grade {
          id
          name
        }

        createdAt
      }
      totalCount
      totalPages
    }
  }
`;

export const VENDOR_OFFERS = gql`
  ${rateUnitFragment}

  query offers(
    $filter: [FilterMap]
    $pageNo: Int
    $pageSize: Int
    $sortCol: String
    $sortDirection: String
  ) {
    offers(
      filter: $filter
      pageNo: $pageNo
      pageSize: $pageSize
      sortCol: $sortCol
      sortDirection: $sortDirection
    ) {
      offers {
        id
        offerType
        minimumQty
        rate
        state {
          id
          stateName
          country {
            id
            country
          }
        }
        city {
          id
          cityName
        }
        grade {
          id
          name
          category {
            id
            name
          }
        }
        rateUnit {
          ...rateUnitInfo
        }

        status
        createdAt

        trader {
          id
          firstName
          lastName
          status
          phone
        }
      }
      totalPages
      totalCount
    }
  }
`;

export const VENDOR_DEMANDS = gql`
  ${rateUnitFragment}
  query demands(
    $filter: [FilterMap]
    $pageNo: Int
    $pageSize: Int
    $sortCol: String
    $sortDirection: String
  ) {
    demands(
      filter: $filter
      pageNo: $pageNo
      pageSize: $pageSize
      sortCol: $sortCol
      sortDirection: $sortDirection
    ) {
      demands {
        id
        demandType
        rate

        state {
          id
          stateName
          country {
            id
            country
          }
        }
        city {
          id
          cityName
        }
        grades {
          id
          name
          category {
            id
            name
          }
        }
        rateUnit {
          ...rateUnitInfo
        }
        status

        trader {
          id
          firstName
          lastName
          status
          phone
        }
      }
      totalPages
      totalCount
    }
  }
`;

export const UPDATE_KYC_STATUS = gql`
  mutation updateTraderKycStatus($id: ID, $isKycVerified: UserKycStatus) {
    updateTraderKycStatus(id: $id, isKycVerified: $isKycVerified)
  }
`;

export const UPDATE_TRADER_STATUS = gql`
  mutation updateUserStatus($id: ID!, $status: ActiveStatus!) {
    updateUserStatus(id: $id, status: $status)
  }
`;

export const UPDATE_TRADER = gql`
  mutation updateTrader($trader: TraderInput) {
    updateTrader(trader: $trader)
  }
`;

export const CREATE_TRADER = gql`
  mutation createTrader($trader: TraderInput) {
    createTrader(trader: $trader) {
      id
    }
  }
`;

export const UPDATE_TRADER_KYC_STATUS = gql`
  mutation updateTraderKycStatus($id: ID, $userKycStatus: UserKycStatus) {
    updateTraderKycStatus(id: $id, userKycStatus: $userKycStatus)
  }
`;

export const UPDATE_WHATSAPP_SUBSCRIPTION = gql`
  mutation updateTraderWhatsappSubscription(
    $traderId: ID!
    $isSubscribed: Boolean
  ) {
    updateTraderWhatsappSubscription(
      traderId: $traderId
      isSubscribed: $isSubscribed
    )
  }
`;

export const RESET_DAILY_PRICE_OPT_OUT = gql`
  mutation resetDailyPriceOptOut($id: ID!, $dailyPriceOptOut: Boolean!) {
    resetDailyPriceOptOut(id: $id, dailyPriceOptOut: $dailyPriceOptOut)
  }
`;


export const UPDATE_TRADER_TDS_ELIGIBLE_STATUS = gql`
  mutation updateTraderTdsEligibleStatus($id: ID, $tdsEligible: Boolean) {
    updateTraderTdsEligibleStatus(id: $id, tdsEligible: $tdsEligible)
  }
`;

export const DELETE_TRADER = gql`
  mutation deleteTrader($id: ID, $deletedBy: String, $deletedFrom: String) {
    deleteTrader(id: $id, deletedBy: $deletedBy, deletedFrom: $deletedFrom)
  }
`;

export const GET_PRESIGNED_URL = gql`
  query getPreSignedPutUrl(
    $contentType: String
    $path: String
    $fileName: String
  ) {
    getPreSignedPutUrl(
      contentType: $contentType
      path: $path
      fileName: $fileName
    )
  }
`;

export const GET_MULTIPLE_PRESIGNED_URLS = gql`
  query generatePreSignedPutUrls($urlParamsListDTO: [UrlGenerationInputDTO]) {
    generatePreSignedPutUrls(urlParamsListDTO: $urlParamsListDTO)
  }
`;

export const EXPORTS_TRADERS = gql`
  query exportTraders(
    $filter: [FilterMap]
    $sortCol: String
    $sortDirection: String
  ) {
    exportTraders(
      filter: $filter
      sortCol: $sortCol
      sortDirection: $sortDirection
    )
  }
`;

export const CREATE_ADDITIONAL_USER = gql`
  mutation createAdditionalUser(
    $traderInputDto: TraderInput
    $callingCodeId: String
    $parentTraderId: ID!
  ) {
    createAdditionalUser(
      traderInputDto: $traderInputDto
      callingCodeId: $callingCodeId
      parentTraderId: $parentTraderId
    ) {
      id
    }
  }
`;

export const DELETE_MULTI_VENDORS = gql`
  mutation deleteTraders($ids: [ID], $deletedBy: String, $deletedFrom: String) {
    deleteTraders(ids: $ids, deletedBy: $deletedBy, deletedFrom: $deletedFrom)
  }
`;

export const SEND_EMAIL_TO_MULTIPLE = gql`
  query sendEmailToMultipleTraders(
    $traderIds: [ID]!
    $subject: String!
    $body: String!
  ) {
    sendEmailToMultipleTraders(
      traderIds: $traderIds
      subject: $subject
      body: $body
    )
  }
`;

export const LIVE_PAYMENT_TERMS_QUERY = gql`
  query livePaymentTerms {
    livePaymentTerms {
      id
      term
    }
  }
`;

export const CREATE_SUBSCRIPTION_PLAN = gql`
  mutation createSubscriptionPlan($createInput: createSubscriptionPlanInput) {
    createSubscriptionPlan(createInput: $createInput) {
      id
    }
  }
`;

export const DEACTIVATE_SUBSCRIPTION_PLAN = gql`
  mutation deactivateTraderSubscriptionPlans($traders: [ID]!) {
    deactivateTraderSubscriptionPlans(traders: $traders)
  }
`;

export const ADDITIONAL_VENDORS_QUERY = gql`
  query traders(
    $filter: [FilterMap]
    $pageNo: Int
    $pageSize: Int
    $sortCol: String
    $sortDirection: String
    $pagination: Boolean
  ) {
    traders(
      filter: $filter
      pageNo: $pageNo
      pageSize: $pageSize
      sortCol: $sortCol
      sortDirection: $sortDirection
      pagination: $pagination
    ) {
      traders {
        id
        firstName
        middleName
        lastName
        entityName
        phone
        status
        tradeName
        tradeGstIn
        createdAt
        email
        profile
        kycStatus
        tdsEligible
        callingCodeId
        companyFormationNumber
        isParentTrader
        callingCode {
          id
          callingCode
          country
        }
        kyc {
          id
          gstPhoto
          gstNumber
          gstStatus
          gstLocation
          panPhoto
          panNumber
          panStatus
          aadharNumber
          aadharFront
          aadharBack
          aadharStatus
          createdAt
          updatedAt
          kycStatus
        }
        addresses {
          id
          houseNumber
          street
          pinCode
          city {
            id
            cityName
          }
          state {
            id
            stateName
          }
          country {
            id
            country
            countryCode
          }
        }
      }
      totalCount
      totalPages
    }
  }
`;

export const SUBSCRIPTION_PLAN_BILLING_AND_PAYMENT_QUERY = gql`
  query userSubscriptionPayments(
    $filter: [FilterMap]
    $pageNo: Int
    $pageSize: Int
    $sortCol: String
    $sortDirection: String
    $pagination: Boolean
  ) {
    userSubscriptionPayments(
      filter: $filter
      pageNo: $pageNo
      pageSize: $pageSize
      sortCol: $sortCol
      sortDirection: $sortDirection
      pagination: $pagination
    ) {
      userSubscriptionPayments {
        id
        totalAmountPaid
        paymentDate
        grandTotal
        createdAt
        currency
        invoiceUrl
        userSubscription {
          id
          deactivationDate
          subscriptionPlan {
            id
            planName
            duration
          }
        }
        addOnPlan {
          id
          planName
          duration
        }
      }
      totalCount
      totalPages
    }
  }
`;

export const USER_SUBSCRIPTION_PLAN_PAYMENT_INVOICE = gql`
  query userSubscriptionPaymentInvoice($id: ID!) {
    userSubscriptionPaymentInvoice(id: $id)
  }
`;

export const GET_USER_ADDON_LISTING = gql`
  query findAddonByTraderId($traderId: ID) {
    findAddonByTraderId(traderId: $traderId) {
      id
      addOnTypes
    }
  }
`;

export const GET_ACCUMULATED_SELLER_COMMISSION = gql`
  query getAccumulatedSellerCommission(
    $fromDate: String!
    $toDate: String!
    $sellerId: ID!
  ) {
    getAccumulatedSellerCommission(
      fromDate: $fromDate
      toDate: $toDate
      sellerId: $sellerId
    ) {
      sellerName
      month
      amount
      qty
      qtyUnit
      currency
      year
    }
  }
`;

export const GET_SELLER_COMMISSION_HISTORY = gql`
  query getSellerCommissionHistory(
    $fromDate: String!
    $toDate: String!
    $sellerId: ID!
    $currency: PaymentCurrency
  ) {
    getSellerCommissionHistory(
      fromDate: $fromDate
      toDate: $toDate
      sellerId: $sellerId
      currency: $currency
    ) {
      month
      monthInt
      year
      totalQty
      totalAmount
      rateUnit
      qtyUnit
      sellerCommissionHistories {
        totalQty
        totalAmount
        sellerId
        sellerName
        rateUnit
        qtyUnit
        orderCommissionHistories {
          qtyUnit
          amount
          currency
          rateUnit
          orderId
          sellerId
          sellerName
          qty
          orderDate
          month
          monthInt
          year
        }
      }
    }
  }
`;

export const UPDATE_USER_SUBSCRIPTION_QUANTITY = gql`
  mutation updateUserSubscription($updateInput: updateUserSubscriptionInput) {
    updateUserSubscription(updateInput: $updateInput) {
      id
      dealQtyUnit
      dealQtyLimit
    }
  }
`;

export const UPDATE_TRADER_DEMAND_COUNT = gql`
  mutation updateTraderDemandCount($id: ID!, $demandCount: Int!) {
    updateTraderDemandCount(id: $id, demandCount: $demandCount)
  }
`;

export const UPDATE_TRADER_DESIGNATION = gql`
  mutation updateTraderDesignation($traderId: ID!, $designation: String!) {
    updateTraderDesignation(traderId: $traderId, designation: $designation)
  }
`;
